import React, { useState } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const CompetenceLineChart = ({ pesId, competenceHistoryData }) => {
  // Processa os dados para o formato que o Recharts espera
  const processedData = {};
  competenceHistoryData.forEach(item => {
    const date = item.data;
    if (!processedData[date]) {
      processedData[date] = { date: date };
    }
    processedData[date][item.competencia] = item.pontuacao;
  });

  const chartData = Object.values(processedData).sort((a, b) => new Date(a.date) - new Date(b.date));

  const allCompetenceNames = Array.from(new Set(chartData.flatMap(item => Object.keys(item).filter(key => key !== 'date'))));
  const [hiddenLines, setHiddenLines] = useState({}); // Mapeia competenceName -> true se escondida

  const colors = ['#8884d8', '#82ca9d', '#ffc658', '#E91E63', '#00BCD4', '#FF9800', '#4CAF50', '#9C27B0'];

  const handleLegendClick = (dataKey) => {
    const { dataKey: clickedCompetence } = dataKey; // Renomeia dataKey para clickedCompetence
    setHiddenLines(prevHiddenLines => {
      const newHiddenLines = { ...prevHiddenLines };
      if (newHiddenLines[clickedCompetence]) {
        // Se estava escondida, mostra
        delete newHiddenLines[clickedCompetence];
      } else {
        // Se estava visível, esconde
        newHiddenLines[clickedCompetence] = true;
      }
      return newHiddenLines;
    });
  };

  const CustomLegend = ({ payload }) => {
    return (
      <ul className="recharts-default-legend" style={{ padding: 0, margin: 0, display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
        {payload.map((entry, index) => {
          const isHidden = hiddenLines[entry.dataKey];
          return (
            <li
              key={`legend-${index}`}
              onClick={() => handleLegendClick(entry)}
              style={{
                display: 'inline-flex',
                marginRight: 10,
                cursor: 'pointer',
                color: isHidden ? '#ccc' : entry.color,
                textDecoration: isHidden ? 'line-through' : 'none',
              }}
            >
              <div
                style={{
                  width: 14,
                  height: 14,
                  backgroundColor: isHidden ? '#ccc' : entry.color,
                  marginRight: 5,
                  borderRadius: 3,
                }}
              />
              {entry.value}
            </li>
          );
        })}
      </ul>
    );
  };

  const formatXAxisTick = (tick) => {
    const date = new Date(tick + 'T00:00:00');
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${day}/${month}`;
  };

  return (
    <div className="bg-white p-4 rounded-lg shadow"> {/* Adicionado background branco */}
      <h3>Evolução de Pontuação de Competências</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={chartData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" tickFormatter={formatXAxisTick} />
          <YAxis domain={[0, 6]} />
          <Tooltip labelFormatter={(label) => {
            const date = new Date(label + 'T00:00:00');
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
          }} />
          <Legend content={<CustomLegend />} />
          {allCompetenceNames.map((competence, index) => (
            <Line
              key={competence}
              type="monotone"
              dataKey={competence}
              stroke={colors[index % colors.length]}
              activeDot={{ r: 8 }}
              hide={hiddenLines[competence]}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CompetenceLineChart;